///include /assets/js/app/p/brand.js
///include /assets/js/app/p/sbproduct/all.js
///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/p/vps.js
///include /assets/js/app/s/catalogue.js
///include /assets/js/app/p/description-template-compiler.js

"use strict"

class SOrderVpsPage {
    init() {
        this.view = new Vue({
            el: "#purchase-vps",
            name: "order-vps-page",
            data() {
                return {
                    brand: null,
                    catalogue: UserCatalogue.inst,
                    dcLocations: [
                        {
                            text: "UK",
                            id: "dc_location-lhr"
                        },
                        {
                            text: "USA",
                            id: "dc_location-dfw"
                        }
                    ],
                    format: Site.Format,
                    installTargetType: "os",
                    platform: VPSPlatform.inst,
                    /** @type {?VPSApplication} */
                    selectedApp: null,
                    /** @type {?boolean} */
                    selectedCPanelObject: null,
                    /** @type {?string} */
                    selectedDiskProduct: null,
                    /** @type {?string} */
                    selectedLocation: "dc_location-lhr",
                    /** @type {?string} */
                    selectedOSGroup: null,
                    /** @type {?{[group: string]: ?string}} Retained */
                    selectedOSVersion: null,
                    /** @type {?number} */
                    selectedPaymentMonths: null,
                    /** @type {?SBVPSProduct} */
                    selectedServerType: null,
                    settings: SharedSettings.inst,
                    type: 'vps',
                    withCpanel: 'no',
                    withDisk: "no",
                    addBackups: false,
                    selectedCpanelCode: "",
                    hasQuery: false,
                }
            },

            computed: {
                vpsDisks() {
                    if (!this.catalogue.products) return null
                    return this.catalogue.products.filter(
                        p => (p instanceof SBVPSAddonProduct && p.code.match(/vps_addon:disk/))
                    ).map((p) => {
                        var price = p.pricing.find(p => p.periodMonths == this.selectedPaymentMonths)
                        return {
                            "text": p.label + ` (+${Site.Format.price(price?.price, this.catalogue.currency)})`,
                            "id": p.code
                        }
                    }).sort((a, b) => {
                        const diskA = parseInt(a.id.match(/\d+/)[0])
                        const diskB = parseInt(b.id.match(/\d+/)[0])
                        return diskA - diskB
                    })
                },
                cPanelProducts() {
                    if (!this.catalogue.products) return null
                    return this.catalogue.products.filter(
                        p => (p instanceof SBVPSAddonProduct && p.typeRef.match(/cpanel/))
                    )
                },
                cPanelAvailableOptionsSelect() {
                    if (this.cPanelProducts) {
                        return this.cPanelProducts.map(c => ({ text: c.label, id: c.code }))
                    }
                    return []
                },
                offerCpanel() {
                    return this.cPanelAvailableOptionsSelect.length > 0
                },
                backupProducts() {
                    if (!this.catalogue.products || !this.selectedServerType) return null
                    return this.catalogue.products.filter(
                        p => (p instanceof SBVPSBackupProduct && p.typeRef == this.selectedServerType.typeRef)
                    )
                },
                loading() {
                    return !(this.serverTypes && this.platform.apps)
                },
                vpsProductByType() {
                    var ps = { "vps": false, "managed_vps": false }
                    if (!this.catalogue.products) return ps
                    for (const p of this.catalogue.products.filter(i =>
                        (i instanceof SBVPSProduct || i instanceof SBManagedVPSProduct) && !i.isHidden
                    )) {
                        ps[p.codePrefix] = true
                    }
                    return ps
                },
                multiVpsOffered() {
                    return !!(this.vpsProductByType['vps'] && this.vpsProductByType['managed_vps'])
                },
                notHiddenServerTypes() {
                    if (!this.serverTypes || !this.serverTypes.length) return []
                    return this.serverTypes.filter(t => !t.isHidden)
                },
                offerVpsDisk() {
                    if (!this.catalogue.products) return null
                    return !!this.catalogue.products.find(p => p.code.match(/^vps_addon:disk/))
                },
                offerVpsLocation() {
                    return true
                },
                operatingSystemsGrouped() {
                    if (!(this.selectedServerType && this.selectedServerType.operatingSystems)) return null
                    /** @type {{[name: string]: SBVPSAnyOS[]}} */
                    const grouped = {}
                    for (const os of this.selectedServerType.operatingSystems) {
                        const name = os.groupName
                        if (!grouped[name]) grouped[name] = []
                        grouped[name].push(os)
                    }
                    for (const oss of Object.values(grouped)) {
                        oss.sort()
                    }
                    return grouped
                },
                pageQuery() {
                    const query = window.location.search.substr(1).split('&')
                    if (!query) return null
                    /** @type {{ type: string, code: string }} */
                    const queryObj = query.reduce((result, q) => {
                        const qParts = q.split('=')
                        result[qParts[0]] = qParts[1]
                        return result
                    }, {})
                    return { query, queryObj }
                },
                possibleMonths() {
                    if (!this.catalogue.products) return null
                    /** @type {number[]} */
                    const periods = []
                    for (const p of this.catalogue.products) {
                        if (this.type == 'vps' && (p instanceof SBVPSProduct || p instanceof SBVPSAddonProduct)) {
                            for (const pricing of p.pricing) {
                                if (!periods.includes(pricing.periodMonths)) {
                                    periods.push(+pricing.periodMonths)
                                }
                            }
                        } else if (this.type == 'managed_vps' && (p instanceof SBManagedVPSProduct || p instanceof SBVPSAddonProduct)) {
                            for (const pricing of p.pricing) {
                                if (!periods.includes(pricing.periodMonths)) {
                                    periods.push(+pricing.periodMonths)
                                }
                            }
                        }
                    }
                    return periods.sort((a, b) => a - b)
                },
                selectedCPanel() {
                    return !!this.selectedCPanelObject
                },
                selectedCPanelProduct() {
                    const os = this.selectedOS
                    if (this.selectedCPanel && os && this.cPanelProducts) {
                        return this.cPanelProducts.find(
                            p => (
                                p.code === this.selectedCPanelObject.code &&
                                p.provisioningRequirements &&
                                p.provisioningRequirements.os.includes(os.typeRef)
                            )
                        )
                    }
                    return null
                },
                /** @type {SBVPSAnyOS | null} */
                selectedOS() {
                    const os_version = this.selectedOSVersion
                    const os_group = this.selectedOSGroup
                    if (!os_group || !os_version || !this.selectedServerType || !this.selectedServerType.operatingSystems) return null
                    return this.selectedServerType.operatingSystems.find(
                        os => os.typeRef == os_version[os_group]
                    ) || null
                },
                selectedProducts() {
                    if (!this.selectedServerType) return []
                    /** @type {SBGeneralProduct[]} */
                    const products = [this.selectedServerType]
                    if (this.selectedOS && this.selectedOS instanceof SBVPSOSProduct) {
                        products.push(this.selectedOS)
                    }
                    if (this.selectedCPanelProduct) {
                        products.push(this.selectedCPanelProduct)
                    }
                    if (this.addBackups) {
                        products.push(this.backupProducts[0])
                    }
                    if (this.selectedDiskProduct) {
                        products.push(this.catalogue.products.find(p => p.code == this.selectedDiskProduct))
                    }
                    return products
                },
                serverTypes() {
                    if (!this.catalogue.products) return null
                    let ps = null
                    if (this.type == 'vps') {
                        ps = this.catalogue.products.filter(p => p instanceof SBVPSProduct)
                    } else if (this.type == 'managed_vps') {
                        ps = this.catalogue.products.filter(p => p instanceof SBManagedVPSProduct)
                    }
                    if (!ps) return ps
                    ps.sort(this.priceSort)
                    return ps
                },
                subtotal() {
                    const totals = this.subtotalByType
                    if (totals) {
                        return Object.values(totals).sort((a, b) => a - b)[0]
                    }
                    return null
                },
                subtotalByType() {
                    const products = this.selectedProducts
                    const months = this.selectedPaymentMonths
                    if (products.length && this.supportedGeneralPaymentMethods && months) {
                        /** @type {{[type: string]: number}} */
                        const totals = {}
                        for (const pm of this.supportedGeneralPaymentMethods) {
                            let total = 0.00
                            let failed = false
                            for (const item of products) {
                                const p = item.initialPriceForGeneral(pm, months)
                                if (p === null) {
                                    failed = true
                                    break
                                } else {
                                    total += p
                                }
                            }
                            if (!failed) totals[pm] = total
                        }
                        return totals
                    }
                    return null
                },
                supportedGeneralPaymentMethods() {
                    if (this.selectedProducts.length) {
                        let payment_methods = this.selectedProducts[0].pricing.map(p => p.paymentType)
                        for (const p of this.selectedProducts) {
                            payment_methods = payment_methods.filter(
                                pm => p.pricing.some(p => p.paymentType == pm)
                            )
                        }
                        return payment_methods
                    }
                    return []
                },
                supportedPaymentMonths() {
                    if (this.selectedProducts.length) {
                        let payment_months = this.possibleMonths
                        if (!payment_months) return []
                        for (const p of this.selectedProducts) {
                            payment_months = payment_months.filter(m => p.pricingSupportsMonths(m))
                        }
                        return payment_months
                    }
                    return []
                },
                backupStepNo() {
                    return this.multiVpsOffered ?
                        (this.offerCpanel ? 5 : 4) :
                        (this.offerCpanel ? 4 : 3)
                },
                locationStepNo() {
                    if (this.type == 'vps' && this.backupProducts && this.backupProducts.length > 0) {
                        return +this.backupStepNo + 1
                    }
                    return +this.backupStepNo
                },
                diskStepNo() {
                    return this.locationStepNo + 1
                },
            },

            methods: {
                cpanelAllowed(os) {
                    return os == 'Alma';
                },
                async addToBasket() {
                    /** @type {SBasket} */
                    const basket = AnyBasket.inst
                    let basket_item = await this.basketItem()
                    basket_item.serviceConfiguration = { "location": this.selectedLocation }
                    const pic = PaymentItemCollection.inst
                    await basket.addWithInfo(
                        { paymentItemCountries: await pic.preloadSingle("countriesFlat") },
                        basket_item
                    )
                    location.href = "/checkout"
                },
                /**
                 * @returns {Promise<SBasketItem>}
                 */
                async basketItem() {
                    if (this.type == 'vps' && !this.selectedOS && !this.selectedApp) {
                        throw new Error("No OS selected")
                    }
                    /** @type {SBVPSProduct} */
                    const server_product = this.selectedProducts[0]
                    const app_ref = this.selectedApp ? this.selectedApp.id : null
                    const os_ref = this.selectedOS ? this.selectedOS.typeRef : null

                    if (!this.subtotalByType) throw new Error("Cannot get totals")
                    const totals = Object.entries(this.subtotalByType)
                    const pt = totals.sort((a, b) => a[1] - b[1])[0][0]
                    const pm = this.selectedPaymentMonths
                    if (!pm) throw new Error("No months")
                    await UserCatalogue.inst.preload(["config", "userVATRate"])
                    /** @type {SBasketItem} */
                    const basket_item = await server_product.basketItem(
                        server_product.pricingForGeneral(pt, pm)
                    )
                    basket_item.name = "vps-" + Math.floor(Math.random() * 100000)
                    basket_item.productOptionSelections = { app: app_ref, os: os_ref }
                    let i = 0
                    for (const p of this.selectedProducts.slice(1)) {
                        const sub_basket_item = await p.basketItem(p.pricingForGeneral(pt, pm))
                        basket_item.dependentItems[i++] = sub_basket_item
                    }
                    return basket_item
                },
                /**
                 * @param {number} m
                 * @returns {{[class_name: string]: boolean}}
                 */
                classForPaymentMonths(m) {
                    return {
                        active: this.selectedPaymentMonths == m,
                        disabled: !this.supportedPaymentMonths.includes(m),
                    }
                },
                /**
                 * @param {number} m
                 * @returns {?string}
                 */
                iconForPaymentMonths(m) {
                    switch (m) {
                        case 1: return "/assets/images/icons/vps/vps-monthly.svg"
                        case 3: return "/assets/images/icons/vps/vps-quarterly.svg"
                        case 6: return "/assets/images/icons/vps/vps-semiannually.svg"
                        case 12: return "/assets/images/icons/vps/vps-yearly.svg"
                        case 24: return "/assets/images/icons/vps/vps-biennally.svg"
                        case 36: return "/assets/images/icons/vps/vps-triennially.svg"
                        default: return null
                    }
                },
                /**
                 * @param {(o: SBVPSAnyOS) => boolean} f
                 */
                ensureOSMatches(f) {
                    if (!(this.selectedOS && f(this.selectedOS))) {
                        const server_type = this.selectedServerType
                        if (!server_type) throw new Error("No server")
                        const os = server_type.operatingSystems
                        if (!os) throw new Error("No OS options")
                        const osVersion = this.selectedOSVersion
                        if (!osVersion) throw new Error("No OS versions")
                        this.selectedOSGroup = null
                        const operating_systems = os.slice(0)
                        operating_systems.sort(this.priceSort)
                        for (const o of operating_systems) {
                            if (f(o)) {
                                this.selectedOSGroup = o.groupName
                                osVersion[o.groupName] = o.typeRef
                                break
                            }
                        }
                    }
                },
                /**
                 * @param {string} type
                 * @param {SBVPSAddonProduct | VPSApplication | SBVPSAnyOS} item
                 */
                imageURLFor(type, item) {
                    if (item instanceof VPSApplication) {
                        return `/assets/images/${type}/${type}-ApplicationId-${item.id}.svg`
                    }
                    return `/assets/images/${type}/${type}-os-${item.typeRef.replace(/[^a-z]/g, "")}.svg`
                },
                /**
                 * @param {number} m
                 * @returns {string}
                 */
                intervalMonthsLabel(m) {
                    return Catalogue.intervalMonthsLabel(m, true)
                },
                /**
                 * @param {SBVPSAnyOS[]} operating_systems
                 * @returns {{id: string, text: string}[]}
                 */
                osOptions(operating_systems) {
                    return operating_systems.map(
                        os => ({ id: os.typeRef, text: os.label || os.typeRef })
                    )
                },
                /**
                 * @param {SBGeneralProduct | SBVPSFreeOS} a
                 * @param {SBGeneralProduct | SBVPSFreeOS} b
                 */
                priceSort(a, b) {
                    if (a.lowestPrice && b.lowestPrice) {
                        return (a.lowestPrice.price || 0) - (b.lowestPrice.price || 0)
                    }
                    return 0
                },
                disableCPanel(os) {
                    if (os != 'CentOS') {
                        this.selectedCPanelObject = null
                    }
                },
                getCPanelLabel(v) {
                    return v.replace('cPanel ', '')
                },
                removeCpanel() {
                    this.selectedCPanelObject = null
                },
                /**
                 * @param {string} type
                 * @param {SBVPSProduct} spec
                 */
                lowestPrice(type, spec) {
                    if (!this.catalogue.products || !this.catalogue.prefs) return {}
                    if (!this._lowestPriceCache) this._lowestPriceCache = {}
                    const key = `${type}:${spec.code}`
                    if (this._lowestPriceCache[key] !== undefined) return this._lowestPriceCache[key]
                    let result
                    if (this.catalogue.prefs.advertiseMonthlyEquivalent) {
                        var prices3 = spec.pricing.slice()
                        prices3.sort((a, b) => (a.price / a.periodMonths) - (b.price / b.periodMonths))
                        result = prices3[0]
                    } else {
                        result = spec.pricing[0]
                    }
                    this._lowestPriceCache[key] = result
                    return result
                },
                /**
                 * Compiles using twig.js a description or default template.
                 *
                 * @param {SBManagedVPSProduct} serverType
                 * @returns {string}
                 */
                serverDescription(serverType) {
                    if (!this._descCache) this._descCache = {}
                    const lang = translation.getActiveLanguage()
                    const key = `${serverType.code}:${lang}`
                    if (this._descCache[key] !== undefined) return this._descCache[key]
                    Site.Format.preferGB = true
                    const descriptionFromCode = this.catalogue.productDescriptionFromCode(serverType.code, lang)
                    let template = (descriptionFromCode && descriptionFromCode.length ? descriptionFromCode : null) ||
                        DefaultTemplateCompiler.getTemplateByType(serverType.codePrefix, lang)
                    let serverSpec = {
                        ram: this.format.GB(serverType.ram),
                        cores: serverType.cores,
                        disc: this.format.GB(serverType.disc)
                    }
                    const result = DefaultTemplateCompiler.compile(template, { serverSpec })
                    // Only cache once productDescription and provisioningInfo have loaded
                    if (this.catalogue.productDescription && serverType.ram !== null && serverType.cores !== null && serverType.disc !== null) {
                        this._descCache[key] = result
                    }
                    return result
                },
            },

            watch: {
                installTargetType() {
                    this.selectedApp = null
                    this.selectedOSGroup = null
                    this.selectedCPanelObject = null
                },
                operatingSystemsGrouped(v) {
                    if (v && !this.selectedOSGroup) {
                        this.selectedOSGroup =
                            Object.keys(v).find(k => v[k].some(o => o.typeRef == "rhel6")) ||
                            "CentOS"
                    }
                },
                /** @param {?VPSApplication} v */
                selectedApp(v) {
                    if (v) {
                        this.selectedCPanelObject = null
                        this.ensureOSMatches(o => o.supportsApp(v.id))
                    }
                },
                withCpanel(v) {
                    if (v == 'no') {
                        this.selectedCPanelObject = null
                    } else if (v == 'yes' && this.cPanelProducts.length > 0) {
                        this.selectedCPanelObject = this.cPanelProducts[0]
                        this.selectedCpanelCode = this.selectedCPanelObject.code
                        this.selectedOSGroup = 'Alma'
                    }
                },
                withDisk(v) {
                    if (v == 'no') {
                        this.selectedDiskProduct = null
                    } else if (v == 'yes' && !this.selectedDiskProduct) {
                        this.selectedDiskProduct = this.vpsDisks[0].id
                    }
                },
                selectedCpanelCode(n) {
                    var c = this.cPanelProducts.find(p => p.code == n)
                    if (c) {
                        this.selectedCPanelObject = c
                    }
                },
                // Merged from the former selectedCPanel watcher — fires directly when the
                // cPanel product object changes so we avoid the extra reactive indirection.
                async selectedCPanelObject(v) {
                    if (v) {
                        const cPanelProducts = this.cPanelProducts
                        if (cPanelProducts) {
                            for (const p of cPanelProducts) {
                                await p.preloadSingle("provisioningRequirements")
                            }
                            this.selectedApp = null
                            this.ensureOSMatches(
                                o => cPanelProducts.some(
                                    p => p.provisioningRequirements.os.includes(o.typeRef)
                                )
                            )
                        }
                    }
                },
                /** @param {SBVPSAnyOS | null} v */
                async selectedOS(v) {
                    if (v && this.selectedApp && !v.supportsApp(this.selectedApp.id)) {
                        this.selectedApp = null
                    }
                    const cPanelProducts = this.cPanelProducts
                    if (cPanelProducts) {
                        for (const p of cPanelProducts) {
                            await p.preloadSingle("provisioningRequirements")
                        }
                        if (
                            this.selectedCPanel &&
                            !(v && cPanelProducts.some(
                                p => p.provisioningRequirements.os.includes(v.typeRef)
                            ))
                        ) {
                            this.selectedCPanelObject = null
                        }
                    }
                },
                /** @param {?SBVPSProduct} v */
                selectedServerType() {
                    this.selectedApp = null
                    this.selectedOSGroup = null
                    this.selectedCPanelObject = null
                },
                serverTypes(v) {
                    if (v && this.pageQuery && this.hasQuery) {
                        const productMatch = v.find(type => type.code === this.pageQuery.queryObj.code)
                        this.selectedServerType = productMatch
                    }
                    if (v && !this.selectedServerType) {
                        this.selectedServerType = v[0]
                    }
                    if (v) {
                        v.forEach(async (p) => {await p.preloadSingle("provisioningInfo")})
                    }
                },
                // Sets this.type to whichever single VPS product type is available when
                // both aren't offered. immediate:true handles the initial catalogue load.
                vpsProductByType: {
                    immediate: true,
                    handler(ps) {
                        if (this.hasQuery) return
                        if (!this.multiVpsOffered) {
                            if (ps['vps']) {
                                this.type = "vps"
                            } else if (ps['managed_vps']) {
                                this.type = "managed_vps"
                            }
                        }
                    }
                },
                /**
                 * @param {number[]} v
                 */
                supportedPaymentMonths(v) {
                    if (!(this.selectedPaymentMonths && v.includes(this.selectedPaymentMonths))) {
                        this.selectedPaymentMonths = v[0] || null
                    }
                },
            },

            components: {
                shopNav: ShopNav,
                vueSelect: VueSelect,
            },

            mounted() {
                this.$watch(
                    () => this.operatingSystemsGrouped,
                    /** @param {{[group: string]: SBVPSAnyOS[]}} v */
                    function(v) {
                        if (v) {
                            const existing_selected_os_version =
                            this.selectedOSVersion || {}
                            const selected_os_version = {}
                            for (const [name, oss] of Object.entries(v)) {
                                if (
                                    !existing_selected_os_version.hasOwnProperty(name)
                                ) {
                                    selected_os_version[name] =
                                        oss[0].typeRef
                                }
                            }
                            this.selectedOSVersion = Object.assign(
                                {},
                                existing_selected_os_version,
                                selected_os_version
                            )
                        }
                    }
                )
                // Fire productDescription in parallel with assertExists so it's ready
                // before the first product cards render, eliminating a waterfall request.
                this.catalogue.preloadSingle("productDescription")
                this.catalogue.assertExists()

                if (!this.pageQuery) return

                const { queryObj: { code, type } } = this.pageQuery

                if (type && code === "upgrade") {
                    return this.type = "managed_vps"
                }

                if (type && code) {
                    this.hasQuery = true
                    this.type = type
                }
            }
        })
    }
}
